import { Fragment } from 'react';

import PaymentForm from './PaymentForm';
import UserInfo from './UserInfo';

const App = () => (
  <Fragment>
    <UserInfo />
    <PaymentForm />
  </Fragment>
);

export default App;
